// Исключительные права принадлежат
export const COPYRIGHT_OPTIONS = {
  user: 1,
  organization: 2,
};

export const STATUSES = {
  active: 1,
  draft: 2,
  archived: 3,
};

export const USER_STATUS_RECORD = {
  // Пользователь зачислен
  credited: 2,
  // Пользователь добавлен в набор (черновик)
  added: 1,
};

export const UNITS_MODEL = {
  course_units: {
    name: 'Темы курса',
    search: 'course-unit',
    create: 'course_units',

  },
  courses: {
    name: 'Курса',
    search: 'course',
    create: 'courses',
  },
  lessons: {
    name: 'Урока',
    search: 'lesson',
    create: 'lesson',
  },
};
export const INPUT_TYPES = {
  number: 1,
  text: 2,
  list: 3,
  file: 4,
  calendar: 6,
};

export const INPUT_TYPES_ICONS = {
  [INPUT_TYPES.text]: 'mdi-text',
  [INPUT_TYPES.list]: 'mdi-checkbox-multiple-marked',
  [INPUT_TYPES.file]: 'mdi-file-document',
  [INPUT_TYPES.number]: 'mdi-numeric-3-box-outline',
  [INPUT_TYPES.calendar]: 'mdi-calendar',
};

export const TASK_TYPES = {
  // Автотест
  auto: 2,
  // Смешанное
  mixed: 1,
};

export const TASK_TYPE_ITEMS = [
  { text: 'Автотест', value: TASK_TYPES.auto },
  { text: 'Смешанное', value: TASK_TYPES.mixed },
];

export const INPUT_TEXT_TYPES = {
  1: 'Указание целого числа',
  2: 'Ввод текста',
  3: 'Выбор одного или нескольких выриантов из списка',
  4: 'Загрузка файла',
  6: 'Указание даты',
};

export const ATTESTATION_STATUSES = {
  excluded: 1,
  enrolled: 2,
  allowedAttestation: 3,
  attestated: 4,
  refusedAttestation: 5,
};

export const ATTESTATION_STATUSES_TEXT = {
  [ATTESTATION_STATUSES.excluded]: 'Отчислен',
  [ATTESTATION_STATUSES.enrolled]: 'Зачислен',
  [ATTESTATION_STATUSES.allowedAttestation]: 'Допущен к аттестации',
  [ATTESTATION_STATUSES.attestated]: 'Аттестован',
  [ATTESTATION_STATUSES.refusedAttestation]: 'Не аттестован',
  null: 'Заявка',
};

export const ATTESTATION_STATUSES_COLORS = {
  [ATTESTATION_STATUSES.excluded]: 'error',
  [ATTESTATION_STATUSES.enrolled]: 'primary',
  [ATTESTATION_STATUSES.allowedAttestation]: 'secondary',
  [ATTESTATION_STATUSES.attestated]: 'success',
  [ATTESTATION_STATUSES.refusedAttestation]: 'warning',
};

// export const ATTESTATION_STATUSES_DATA = {
//   [ATTESTATION_STATUSES.excluded]: {
//     value: ATTESTATION_STATUSES.excluded,
//     color: ATTESTATION_STATUSES_COLORS[ATTESTATION_STATUSES.excluded],
//     text: ATTESTATION_STATUSES_TEXT[ATTESTATION_STATUSES.excluded],
//   },
//   [ATTESTATION_STATUSES.enrolled]: {
//     value: ATTESTATION_STATUSES.excluded,
//     color: ATTESTATION_STATUSES_COLORS[ATTESTATION_STATUSES.excluded],
//     text: ATTESTATION_STATUSES_TEXT[ATTESTATION_STATUSES.excluded],
//   },
//   [ATTESTATION_STATUSES.allowedAttestation]: {
//     value: ATTESTATION_STATUSES.excluded,
//     color: ATTESTATION_STATUSES_COLORS[ATTESTATION_STATUSES.excluded],
//     text: ATTESTATION_STATUSES_TEXT[ATTESTATION_STATUSES.excluded],
//   },,
//   [ATTESTATION_STATUSES.attestated]: {
//     value: ATTESTATION_STATUSES.excluded,
//     color: ATTESTATION_STATUSES_COLORS[ATTESTATION_STATUSES.excluded],
//     text: ATTESTATION_STATUSES_TEXT[ATTESTATION_STATUSES.excluded],
//   },
//   [ATTESTATION_STATUSES.refusedAttestation]: {
//     value: ATTESTATION_STATUSES.excluded,
//     color: ATTESTATION_STATUSES_COLORS[ATTESTATION_STATUSES.excluded],
//     text: ATTESTATION_STATUSES_TEXT[ATTESTATION_STATUSES.excluded],
//   },
// };

export const ATTESTATION_STATUSES_ADMITTANCE = [
  {
    value: ATTESTATION_STATUSES.enrolled,
    text: ATTESTATION_STATUSES_TEXT[ATTESTATION_STATUSES.enrolled],
  },
  {
    value: ATTESTATION_STATUSES.allowedAttestation,
    text: ATTESTATION_STATUSES_TEXT[ATTESTATION_STATUSES.allowedAttestation],
  },
];

export const ENROLLMENT_MODES = {
  enroll: 1,
  education: 2,
  settings: 3,
  bureaucracy: 4,
};

export const COURSE_SERVICE = {
  organization: 1,
  supervisor: 2,
  student: 3,
  all: 4,
};

export default {
  COPYRIGHT_OPTIONS,
  COURSE_SERVICE,
  STATUSES,
  UNITS_MODEL,
  ENROLLMENT_MODES,
  ATTESTATION_STATUSES_TEXT,
  ATTESTATION_STATUSES,
  ATTESTATION_STATUSES_COLORS,
};
